export default __webpack_public_path__ + "static/media/hamburger_menu.c0fda5ae.svg";